import React, { useMemo, useCallback } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Slider as FluentSlider } from '@fluentui/react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { CompetitorSliderView } from '@bingads-webui-react/budget-control';
import { FALLBACK_ESTIMATES } from './consts';
import { getSliderStyles, sliderStyles } from './styles/get-slider-styles';

const RANGE_STEP = 0.01;

export const Slider = ({
  ariaLabel,
  budgetValue,
  onBudgetSliderChange,
  budgetSuggestion,
  showCompetitorSlider,
}) => {
  const classes = useDefaultStyles(getSliderStyles);

  const budgetSuggestionWithFallback = useMemo(() => (
    _.isEmpty(budgetSuggestion) ? FALLBACK_ESTIMATES :
      budgetSuggestion
  ), [budgetSuggestion]);

  const onChange = useCallback((val) => {
    const stringifiedValue = val && val.toString();
    if (stringifiedValue) {
      return onBudgetSliderChange(stringifiedValue);
    }
    return _.noop;
  }, [onBudgetSliderChange]);

  return (
    <div className={classNames(classes.sliderContainer, 'budget-slider')} >
      <FluentSlider
        min={Number(_.get(budgetSuggestionWithFallback, ['GlobalMinimumBudget', 'DailyBudget']))}
        max={Number(_.get(budgetSuggestionWithFallback, ['MaximumBudget', 'DailyBudget']))}
        value={budgetValue}
        step={RANGE_STEP}
        showValue={false}
        onChange={onChange}
        styles={sliderStyles}
        aria-label={ariaLabel}
      />

      {
        showCompetitorSlider && budgetSuggestion &&
        <CompetitorSliderView
          budgetSuggestion={budgetSuggestion}
          classes={classes}
          onRenderInlineHelp={() => { /* TODO */ }}
        />
      }
    </div>
  );
};

Slider.propTypes = {
  ariaLabel: PropTypes.string,
  onBudgetSliderChange: PropTypes.func.isRequired,
  budgetValue: PropTypes.string.isRequired,
  showCompetitorSlider: PropTypes.bool,
  budgetSuggestion: PropTypes.shape({}),
};

Slider.defaultProps = {
  ariaLabel: '',
  showCompetitorSlider: true,
  budgetSuggestion: undefined,
};

